import React from 'react';

import { Avatar, Tooltip } from 'antd';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import ContactAvatar from '@components/ContactAvatarGroup/ContactAvatar';

const ContactAvatarGroup = ({ contactIDs, maxCount = 4, size = 'large' }) => {
    if (contactIDs && contactIDs.length > 0) {
        return (
            <Avatar.Group maxCount={maxCount} size={size}>
                {contactIDs.map((contactID) => (
                    <Tooltip key={contactID} title={getContactName(contactID)} placement="top">
                        <ContactAvatar key={contactID} contactID={contactID} />
                    </Tooltip>
                ))}
            </Avatar.Group>
        );
    }
    return <small>no contacts</small>;
};

export default ContactAvatarGroup;
